// react
import { ReactNode } from 'react';

// types
import { Ifr, Transaction } from '../../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// mui
import { Typography } from '@mui/material';

// ui
import { Currency } from '../../../ui/Currency/Currency';
import { Time } from '../../../ui/Time/Time';
import { Table, TableHeader, TableProps } from '../../../ui/Table/Table';

// links
import { LinkIfr } from '../../../links/LinkIfr/LinkIfr';

// props
export interface TableBasicIfrsProps extends Omit<TableProps, 'headers'> {
	data: Ifr[];
	transaction?: Transaction;
}

export const TableBasicIfrs = ({ data = [], transaction, ...props }: TableBasicIfrsProps) => {
	// hooks
	const { t } = useTranslation();

	// vars
	const headers = [
		{
			label: t('name'),
			render: (name: string, header: TableHeader, ifr: Ifr) => {
				return <LinkIfr ifr={ifr} />;
			},
			value: 'name',
		},
		{
			label: t('startDate'),
			render: (dateStart: string) => {
				return <Time date={dateStart} />;
			},
			value: 'dateStart',
		},
		{
			label: t('endDate'),
			render: (dateEnd: string) => {
				let asterisk: ReactNode = '';

				if (transaction?.created) {
					if (new Date(transaction.created) > new Date(dateEnd)) {
						asterisk = (
							<Typography color="error" component="span">
								{' '}
								*
							</Typography>
						);
					}
				}
				return (
					<>
						<Time date={dateEnd} />
						{asterisk}
					</>
				);
			},
			value: 'dateEnd',
		},
		{
			label: t('currency'),
			render: (currency: string) => {
				return <Currency currency={currency} />;
			},
			value: 'currency',
		},
	];
	return <Table {...props} data={data} headers={headers} />;
};
